import { Box, Grid, Typography } from '@mui/material';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { Gridstyles } from '../Investments/investor-application';
import { KeyValue } from './contributor';
import { SubHeading } from '../investors/components';
import { CustodianMaster } from '../../utils/constant';
import { checkApplicableForYes } from '../../utils/utilityFunctions';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';

export default function DistributorDetails({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  const userIsRia = checkApplicableForYes(application?.distributor?.isRia || '');
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
                Maker Details
              </Typography>
            </Grid>

            {application.srm_id && (
              <Box sx={{ width: '100%' }}>
                <SubHeading
                  sx={{
                    color: 'common.black',
                    letterSpacing: 0.5 + 'px',
                    padding: { xs: '10px 10px', sm: '10px 30px' },
                  }}>
                  SRM Details
                </SubHeading>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pt={1}
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue title={"SRM's Name"} description={application?.srm?.name} />
                    <KeyValue
                      title={"SRM's Email Address"}
                      description={application?.srm?.user?.email}
                    />
                    <KeyValue
                      title={"SRM's Mobile Number"}
                      description={application?.srm?.user?.phone}
                    />
                  </Grid>
                </Gridstyles>
              </Box>
            )}
            {application?.distributor && (
              <Box sx={{ width: '100%' }}>
                <SubHeading
                  sx={{
                    color: 'common.black',
                    letterSpacing: 0.5 + 'px',
                    padding: { xs: '10px 10px', sm: '10px 30px' },
                  }}>
                  {` ${userIsRia ? 'RIA' : 'Distributor'}
                   Details`}
                </SubHeading>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pt={1}
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue
                      title={`${userIsRia ? 'RIA' : 'Distributor'} Code`}
                      description={application?.distributor?.arnCode}
                    />
                    {application?.distributor?.type === 'individual' && (
                      <KeyValue
                        title={`${userIsRia ? 'RIA' : 'Distributor'} NISM Certificate Number`}
                        description={application?.distributor?.nismNumber}
                      />
                    )}

                    <KeyValue
                      title={`${userIsRia ? 'RIA' : 'Distributor'} Name`}
                      description={application?.distributor?.name}
                    />
                    <KeyValue
                      title={`${userIsRia ? "RIA's" : "Distributor's"} RM Code`}
                      description={application?.subDistributor?.distributors_RM_Code}
                    />
                    <KeyValue
                      title={`${userIsRia ? "RIA's" : "Distributor's"} RM Name`}
                      description={application?.subDistributor?.user?.firstName}
                    />
                    <KeyValue
                      title={`${userIsRia ? 'RIA' : 'Distributor'} Email`}
                      description={
                        application?.subDistributor?.user?.email ||
                        application?.distributor?.user?.email
                      }
                    />
                    <KeyValue
                      title={`${userIsRia ? 'RIA' : 'Distributor'}  Mobile Number`}
                      description={
                        application?.subDistributor?.user?.phone ||
                        application?.distributor?.user?.phone
                      }
                    />
                    <KeyValue
                      title={`${userIsRia ? 'RIA' : 'Distributor'}'s RM NISM Certificate Number`}
                      description={application?.subDistributor?.nismNumber}
                    />
                    {!application?.srm_id && (
                      <KeyValue title={'Filled By'} description={application?.filledBy} />
                    )}
                  </Grid>
                </Gridstyles>
              </Box>
            )}
            {application.rm_id && (
              <Box sx={{ width: '100%' }}>
                <SubHeading
                  sx={{
                    color: 'common.black',
                    letterSpacing: 0.5 + 'px',
                    padding: { xs: '10px 10px', sm: '10px 30px' },
                  }}>
                  RM Details
                </SubHeading>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pt={1}
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue title={'RM Name'} description={application?.rm?.name} />
                    <KeyValue
                      title={"RM's Email Address"}
                      description={application?.rm?.user?.email}
                    />
                    <KeyValue
                      title={"RM's Mobile Number"}
                      description={application?.rm?.user?.phone}
                    />
                    <KeyValue
                      title={"RM's NISM Certificate Number"}
                      description={application?.rm?.nismNumber}
                    />
                  </Grid>
                </Gridstyles>
              </Box>
            )}

            <Box sx={{ width: '100%' }}>
              <Gridstyles>
                <Grid
                  item
                  container
                  pt={1}
                  pb={5}
                  rowSpacing={6}
                  columnSpacing={13}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-start">
                  {application?.custodian && (
                    <KeyValue
                      title="Custodian Name"
                      description={CustodianMaster[application?.custodian || '']}
                    />
                  )}
                </Grid>
              </Gridstyles>
            </Box>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
